import { trackMoveAction } from '../../../_common/client/tracking';

export const addMoveTrackingToMoreReviewsButton = (rootElement: HTMLElement) => {
    const moreReviewsButton = rootElement.querySelector('.cr_more-reviews-button');
    if (moreReviewsButton) {
        moreReviewsButton.addEventListener('click', () => {
            trackMoveAction({ ot_PageCluster: ['Artikeldetailseite'], review_Navigation: ['bottom'] }, { name: 'click', features: [] });
        });
    }
};
